module.exports = __webpack_public_path__ + "static/img/1684_phase_function_Paper_PointsHejduk_Prediction.bf375cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1684_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Y8cV
// module chunks = 0